// extracted by mini-css-extract-plugin
export default {"root":"jbrj02","bg":"IvR70V"};